import { useState } from "react"


export const BicycleCardBottom=()=>{
    const [cardViewActive,setCardViewActive]=useState(false)
    
    return(
        <>
            <div className={`card-more-content ${cardViewActive?'card-content-active':''}`}>
                smth must be here
            </div>
            <div onClick={()=>setCardViewActive(!cardViewActive)} className={`arrow ${cardViewActive?'card-arrow-active':''}`}>
            <img  src={require('../../static/arrow.png')}/>
            </div>
        </>
    )
}